"use client";

import { FormProvider } from "@/integrations/forms/FormProvider";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function PastaCurl({
  className = ""
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <path d="M1 8 C 4 2, 10 2, 13 8 S 22 14, 25 8 S 31 2, 31 8" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" fill="none" />
    </svg>;
}
export default function TechnicalInquiryForm() {
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: formRef,
    isVisible: formVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const notes = [{
    id: 1,
    text: "Direct manufacturer sourcing"
  }, {
    id: 2,
    text: "CE certified materials"
  }, {
    id: 3,
    text: "Fast European delivery"
  }];
  return <section data-section-id="1021" id="technical-inquiry-form" className="relative bg-background py-24 md:py-44 overflow-hidden">
      <div className="relative container mx-auto px-6 md:px-10 lg:px-16 max-w-[1320px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div ref={introRef} className={`relative lg:col-span-5 transition-all duration-[720ms] ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div aria-hidden className="absolute -top-8 -left-4 md:-left-8 pointer-events-none select-none font-serif font-normal leading-none text-primary opacity-[0.09] text-[16rem] md:text-[22rem]" style={{
            WebkitTextStroke: "1.5px hsl(0 85% 45%)",
            color: "transparent"
          }}>
              02
            </div>

            <div className="relative">
              <p className="font-mono text-[0.7rem] md:text-[0.8125rem] tracking-[0.18em] uppercase text-muted-foreground font-medium mb-8">
                — § 02 · REQUEST QUOTE
              </p>

              <h2 className="font-default text-[clamp(2.25rem,5vw,4.25rem)] leading-[1.02] tracking-tight text-foreground mb-8">
                Get Your{" "}
                <em className={`font-normal italic text-primary inline-block transition-all duration-[600ms] ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`} style={{
                transitionDelay: introVisible ? "200ms" : "0ms"
              }}>
                  Quote
                </em>
              </h2>

              <p className="font-default text-[clamp(1.0625rem,1.35vw,1.25rem)] leading-relaxed text-muted-foreground max-w-[40ch] mb-10">
                Swiss Solutions provides premium construction materials with precision engineering. Request a quote for your project today.
              </p>

              <ul className="space-y-3 mb-10">
                {notes.map((note, i) => <li key={note.id} data-index={i} className="flex items-start gap-3 font-default text-[0.9rem] text-muted-foreground">
                    <PastaCurl className="w-6 h-3 mt-1.5 shrink-0 text-primary" />
                    <span>— {note.text}</span>
                  </li>)}
              </ul>

              <div className="pt-6 border-t border-dotted border-border">
                <p className="font-mono text-sm text-muted-foreground mb-1 tracking-[0.04em]">
                  — Or call us directly
                </p>
                <Link to="tel:+41765350002" className="font-mono text-base md:text-lg text-primary tracking-[0.04em] hover:underline underline-offset-4">
                  +41 76 535 00 02
                </Link>
              </div>
            </div>
          </div>

          <div ref={formRef} className={`lg:col-span-7 transition-all duration-[720ms] ease-out ${formVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: formVisible ? "120ms" : "0ms"
        }}>
            <FormProvider formKey="technical_inquiry_form_contact" formId="technical_inquiry_form_contact" sectionName="technical-inquiry-form" defaultValues={{
            name: "",
            email: "",
            phone: "",
            reservation_date: "",
            reservation_time: "",
            party_size: "",
            occasion: "",
            special_requests: "",
            newsletter: false
          }} validationRules={{
            name: {
              required: true,
              minLength: 2,
              maxLength: 50
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true,
              pattern: "phone"
            },
            reservation_date: {
              required: true
            },
            reservation_time: {
              required: true
            },
            party_size: {
              required: true
            }
          }} submitText="Request Quote" successMessage="Thank you! Your request has been received. Our team will contact you shortly." errorMessage="We couldn't process your request. Please try again or call us directly.">
              <div dangerouslySetInnerHTML={{
              __html: '[contact-form-7 id="e1742cd" title="Quote Request Form"]'
            }} />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}